// extracted by mini-css-extract-plugin
export default {"container":"AboutTeam_container__bb6cj","title":"AboutTeam_title__yNCsK","text-appear":"AboutTeam_text-appear__TJiCw","text":"AboutTeam_text__2rlVP"};